export class HttpError extends Error {
  response: any
  status: number

  constructor(message: string, response: any, status: number) {
    super(message)
    this.response = response
    this.status = status
  }
}

export class FileError extends Error {
  file: File
  type: string
  meta?: Record<string, any>

  constructor(
    message: string,
    file: File,
    type: string,
    meta?: Record<string, any>,
  ) {
    super(message)
    this.file = file
    this.type = type
    this.meta = meta
  }
}
